import { useState } from "react";
import { DISPLAY_LANG } from "../../../config";
import './ModalHostingUpgradeBillingType.css';

const pageData = {
    en: {
        title: "Choose Billing Type",
        description: "How would you like to pay for your hosting?",
        monthly_btn: "Monthly",
        yearly_btn: "Yearly"
    },
    am: {
        title: "Ընտրեք վճարման տեսակը",
        description: "Ինչպե՞ս կցանկանայիք վճարել ձեր հոսթինգի համար։",
        monthly_btn: "Ամսական",
        yearly_btn: "Տարեկան"
    },
    ru: {
        title: "Выберите тип оплаты",
        description: "Как вы хотите оплатить хостинг?",
        monthly_btn: "Ежемесячно",
        yearly_btn: "Ежегодно"
    }
};

export default function ModalHostingUpgradeBillingType({ onClose, onSelect }) {
  const [selected, setSelected] = useState(null);

  const handleSelect = (type) => {
    setSelected(type);
    if (onSelect) onSelect(type);
  };

  return (
    <div className="modal-wrapper">
      <div className="modal-overlay">
        <div className="modal">
          <div className="modal-header">
            <h2>{pageData[DISPLAY_LANG].title}</h2>
            <button className="close-btn" onClick={onClose}>&times;</button>
          </div>

          <div className="modal-body">
            <p>{pageData[DISPLAY_LANG].description}</p>

            <div className="billing-buttons">
              <button
                className={`billing-btn ${selected === "monthly" ? "active" : ""}`}
                onClick={() => handleSelect("monthly")}
              >
                {pageData[DISPLAY_LANG].monthly_btn}
              </button>

              <button
                className={`billing-btn ${selected === "yearly" ? "active" : ""}`}
                onClick={() => handleSelect("yearly")}
              >
                {pageData[DISPLAY_LANG].yearly_btn}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}